import { styled } from "@material-ui/core/styles";

// Shared wrapper for Event Detail tabs. Full-bleed on mobile, capped to a
// readable column on wide screens, and centered in the Event Detail shell.
const TabContent = styled("div")({
  width: "100%",
  maxWidth: 720,
  marginLeft: "auto",
  marginRight: "auto",
});

export default TabContent;
